<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-log-search`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34 28a8 8 0 017.125 11.642l3.296 3.296a1 1 0 010 1.414l-1.697 1.697a1 1 0 01-1.414 0l-3.19-3.19A8 8 0 1134 28zm6-26a2 2 0 012 2v18h-4V6H10v36h12v4H8a2 2 0 01-2-2V4a2 2 0 012-2h32zm-6 30a4 4 0 100 8 4 4 0 000-8zm-9-10a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h10zm8-8a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18z"/></svg>
</template>
<script>

export default {
  name: 'IconLogSearch',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
